<div class="stepper-container w-100 bg-transparent">
  @if(isMobileView){
  <div class="mobile-stepper d-flex justify-content-between align-items-start w-100">
    @for (step of steps; track step.id; let last = $last) {
    <div class="step-item d-flex flex-column align-items-center position-relative"
      [class.active]="step.id === currentStep()" [class.completed]="step.id < currentStep()">

      <div class="node-row d-flex align-items-center justify-content-center w-100 position-relative">
        <div class="step-circle d-flex align-items-center justify-content-center">
          {{ step.id }}
        </div>
        @if (!last) {
        <div class="progress-line"></div>
        }
      </div>

      <div class="label-container mt-2 text-center">
        <span class="step-title">{{ step.titleKey | translate }}</span>
      </div>
    </div>
    }
  </div>
  }
  @else{
  <div class="desktop-stepper d-flex align-items-start w-100">
    @for (step of steps; track step.id; let last = $last) {
    <div class="step-item d-flex flex-column align-items-center position-relative"
      [class.active]="step.id === currentStep()" [class.completed]="step.id < currentStep()">

      <div class="step-node-wrapper d-flex align-items-center justify-content-center position-relative w-100">
        <div class="step-circle d-flex align-items-center justify-content-center">
          {{ step.id }}
        </div>
        @if (!last) {
        <div class="progress-line"></div>
        }
      </div>

      <div class="label-container d-flex flex-column align-items-center mt-2 ion-text-center">
        <h3 class="step-title">{{ step.titleKey | translate }}</h3>
      </div>
    </div>
    }
  </div>
  }
</div>